<a *ngIf="IOS_APP" [href]="IOS_APP" download="" target="_blank" class="btn-applestore">
  <img src="{{sharedService.imagesUrl}}app-store-badge.png" />
</a>